function hasLicenseProfileRef(organisation = {}) {
  const id = organisation.license_permission_profile_id;
  return id !== null && id !== undefined && id !== '';
}

export function getPermissionProfileFromLicense(license) {
  if (!license) return null;

  const id = license.permissionProfileId ?? license.permissionProfile?.id;
  if (id == null || id === '') return null;

  return {
    id: String(id),
    name: license.permissionProfile?.name ?? '',
  };
}

export function findLicenseById(licenses, licenseId) {
  if (!licenseId) return null;
  return licenses.find((item) => String(item.id) === String(licenseId)) ?? null;
}

export function patchOrganisationWithLicenseProfile(organisation, licenses = []) {
  if (!organisation?.license_id) return organisation;

  const existingRef = hasLicenseProfileRef(organisation);
  if (existingRef) return organisation;

  const license = findLicenseById(licenses, organisation.license_id);
  const profile = getPermissionProfileFromLicense(license);
  if (!profile) return organisation;

  return {
    ...organisation,
    license_alias: organisation.license_alias || license?.alias || license?.name || '',
    license_permission_profile_id: profile.id,
    license_permission_profile_name: profile.name,
  };
}

export function organisationNeedsLicenseProfileResolve(organisation) {
  if (!organisation?.license_id) return false;
  return !hasLicenseProfileRef(organisation);
}
